import { render, staticRenderFns } from "./contractDeduction.vue?vue&type=template&id=0bc39082&scoped=true&"
import script from "./contractDeduction.vue?vue&type=script&lang=js&"
export * from "./contractDeduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc39082",
  null
  
)

export default component.exports